import { Record } from "immutable";

import { UserModel } from "./UserModel";

const defaults = {
  createdAt: new Date(0),
  creator: null as null | UserModel,
  id: "",
  lastUsedAt: null as Date | null,
  name: "",
  refreshedAt: null as Date | null,
  value: "",
};

export class AgentTokenModel extends Record<typeof defaults>(defaults) {
  static fromServerData(data: unknown) {
    const { createdAt, creator, id, lastUsedAt, name, refreshedAt, value } = data as typeof defaults;
    return new AgentTokenModel({
      createdAt: new Date(createdAt),
      creator: creator ? UserModel.fromServerData(creator) : null,
      id,
      lastUsedAt: lastUsedAt ? new Date(lastUsedAt) : null,
      name,
      refreshedAt: refreshedAt ? new Date(refreshedAt) : null,
      value,
    });
  }
}
